import {
  UPDATE_NAVIGATION_COLLAPSED,
  UPDATE_SHOW_INVITE_TEAMMATE_TOOLTIP,
} from '../constants/actions';

const DEFAULT_LAYOUT_STATE = {
  isNavigationCollapsed: false,
  showInviteToolTip: false,
};

const layoutReducer = (state = DEFAULT_LAYOUT_STATE, action) => {
  switch (action.type) {
    case UPDATE_NAVIGATION_COLLAPSED:
      return {
        ...state,
        isNavigationCollapsed: action.isCollapsed,
      };
    case UPDATE_SHOW_INVITE_TEAMMATE_TOOLTIP:
      return {
        ...state,
        showInviteToolTip: action.showInviteToolTip,
      };
    default:
      return state;
  }
};

export default layoutReducer;
